module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/customer-search-typeahead/customer-search-typeahead.component.scss
// module id = ./src/app/modules/common-module/components/customer-search-typeahead/customer-search-typeahead.component.scss
// module chunks = 9